var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Heading',{attrs:{"value":_vm.value,"BlocksIndex":_vm.BlocksIndex,"placeholder":_vm.placeholder,"fontSize":"20px"}})}
var staticRenderFns = []

export { render, staticRenderFns }